import React, { useEffect, useState } from 'react';
import BookingFlow from '../../Shared/BookingFlow/BookingFlow';
import { getTeamShoots } from '../../../../utils/APIs/servicesApis';

const HourlyBookingFlow = () => {
    const [pricing, setPricing] = useState(null);
    const [loading, setLoading] = useState(true);

    const getImageForRole = (role) => {
        switch (role) {
            case 'Photographer': return 'Add1.png';
            case 'Videographer': return 'Add2.png';
            case 'Lighting Setup': return 'Add3.png';
            case 'Editing': return 'Add4.png';
            default: return 'Add1.png';
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await getTeamShoots('standard');
                if (response.data.success) {
                    const apiData = response.data.data;
                    const plansMap = {};

                    const teamMembers = apiData.map(item => {
                        const member = {
                            id: item._id,
                            title: item.role,
                            features: item.features,
                            image: getImageForRole(item.role),
                            pricingType: item.pricingType,
                            originalData: item
                        };

                        if (item.pricingType === 'duration_based' && item.pricingOptions) {
                            member.prices = {};
                            item.pricingOptions.forEach((opt, index) => {
                                // Fallback to durationText or index if durationValue is missing
                                const durationVal = opt.durationValue !== undefined ? opt.durationValue : opt.durationText;
                                if (durationVal === undefined) return;

                                const pId = durationVal.toString();
                                member.prices[pId] = opt.price;
                                if (!plansMap[pId]) {
                                    plansMap[pId] = {
                                        id: pId,
                                        duration: opt.durationText || `${durationVal} Hours`,
                                        subtitle: opt.subtitle || '',
                                        price: opt.price
                                    };
                                }
                            });
                        } else {
                            member.price = item.fixedPrice;
                        }
                        return member;
                    });

                    const plans = Object.values(plansMap).sort((a, b) => Number(a.id) - Number(b.id));
                    setPricing({ plans, teamMembers });
                }
            } catch (error) {
                console.error("Error fetching standard pricing:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) return <div className="bf-loading">Loading...</div>;
    if (!pricing) return <div className="bf-error">Please log in to view pricing details..</div>;

    return <BookingFlow pricing={pricing} />;
};

export default HourlyBookingFlow;
